<template>
  <div v-if="show" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <!-- Background overlay -->
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" @click="close"></div>

      <!-- Modal panel -->
      <div class="inline-block align-bottom bg-white rounded-lg px-6 pt-5 pb-6 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-8">
        <!-- Header -->
        <div class="text-center">
          <h2 class="text-2xl font-bold text-gray-900 mb-2">
            Preview Changes
          </h2>
          <p class="text-sm text-gray-500">
            Review your subscription changes before confirming
          </p>
        </div>

        <!-- Summary Section -->
        <div class="mt-8 bg-gray-50 rounded-lg p-4 mb-6">
          <div class="grid grid-cols-2 gap-4 text-sm">
            
            <div>
              <p class="text-gray-500">Plan</p>
              <p class="font-medium">{{ selection?.plan?.name || 'No plan selected' }}</p>
            </div>
            <div>
              <p class="text-gray-500">Billing Cycle</p>
              <p class="font-medium">{{ billingCycle }}</p>
            </div>
            
          </div>
        </div>

        <!-- Line Items Table -->
        <div class="mb-6">
          <h3 class="text-md font-medium text-gray-900 mb-4">Order Summary</h3>
          
          <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
              <thead>
                <tr>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Description</th>
                  <th scope="col" class="px-3 py-3 text-right text-xs font-medium text-white uppercase tracking-wider">Amount</th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="(item, index) in previewData.lines" :key="index">
                  <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-900">
                    {{ item.description }}
                    <div v-if="item.proration" class="text-xs text-gray-500">
                      Prorated amount
                    </div>
                  </td>
                  <td class="px-3 py-3 whitespace-nowrap text-sm text-right" :class="{ 'text-red-600': item.amount < 0, 'text-gray-900': item.amount >= 0 }">
                    {{ formatCurrencyCents(item.amount) }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-lg p-2 font-bold text-gray-900 mt-2 flex justify-between">
              <span>Total amount due:</span>
              <span>
                {{ formatCurrencyCents(previewData.amount_due) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="mt-6 flex flex-col sm:flex-row-reverse sm:justify-between sm:space-x-4">
          <button
            type="button"
            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-6 py-3 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:w-auto sm:text-sm"
            @click="$emit('confirm')"
            :disabled="isCommitting"
            :class="{'opacity-50 cursor-not-allowed': isCommitting}"
          >
            {{ isCommitting ? 'Processing...' : 'Confirm Changes' }}
          </button>
          <button
            type="button"
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-6 py-3 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:w-auto sm:text-sm"
            @click="close"
            :disabled="isCommitting"
            :class="{'opacity-50 cursor-not-allowed': isCommitting}"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrencyCents } from '../../utils/formatters';
export default {
  name: 'SubscriptionPreview',
  props: {
    value: Boolean,
    previewData: {
      type: Object,
      default: () => ({
        period_end: null,
        items: [],
        amount_due: 0,
        current_subscription: {},
        new_subscription: {},
        selection: {}
      })
    },
    isCommitting: {
      type: Boolean,
      default: false
    },
    currentPlan: {
      type: Object,
      default: () => ({})
    },
    newPlan: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      show: this.value,
      loading: false
    };
  },
  computed: {
    selection() {
      console.log('Selection:', this.previewData.selection);
      return this.previewData.selection;
    },
    billingCycle() {
      return this.newPlan?.interval || 'month';
    },

    currentPlanPrice() {
      return this.currentPlan?.amount || this.previewData.current_subscription?.plan?.amount || 0;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        console.log('value changed:', newVal);
        this.show = newVal;
      }
    },
    show(newVal) {
      console.log('show changed:', newVal);
      if (newVal !== this.value) {
        console.log('emitting input event with:', newVal);
        this.$emit('input', newVal);
      }
    },
    previewData: {
      deep: true,
      handler(newVal) {
        console.log('previewData updated:', newVal);
      }
    }
  },
  methods: {
    close() {
      this.show = false;
      this.$emit('close');
    },
    formatCurrencyCents(cents, currency = 'USD') {
      return formatCurrencyCents(cents, currency);
    },

  }
};
</script>
